// 确定性出题:UTC 日期 + FNV-1a 哈希取模。纯前端可算,全球同一 UTC 日同一答案。

export function todayKey(d = new Date()): string {
  return d.toISOString().slice(0, 10); // UTC 'YYYY-MM-DD'
}

/** 32-bit FNV-1a,稳定哈希,跨端一致 */
export function fnv1a(str: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

/** 每个模式用不同种子,保证同一天各模式答案不同 */
export function dailyIndex(mode: string, poolLen: number, key = todayKey()): number {
  return fnv1a(`${key}:${mode}`) % poolLen;
}

const EPOCH = '2026-06-20'; // 上线日 = #1

/** 当日期号(从上线日起计) */
export function gameNumber(key = todayKey()): number {
  const a = Date.parse(EPOCH + 'T00:00:00Z');
  const b = Date.parse(key + 'T00:00:00Z');
  return Math.floor((b - a) / 86_400_000) + 1;
}

/** 给定 UTC 日的前一天 */
export function prevDay(key: string): string {
  return new Date(Date.parse(key + 'T00:00:00Z') - 86_400_000).toISOString().slice(0, 10);
}
